import React from 'react';
import VictimInfo from './items/VictimInfo';
//Función principal
const AudienceVictims = props => {
    //Tomo los props
    const { audience } = props;
    //Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">VICTIMA/S</h6>
                </div>
                <div className="card-body">
                    <div className="row">
                        {
                            audience.victimaList.map((victim, index) => (
                                <VictimInfo
                                    key={`vi${victim.id}`}
                                    index={index}
                                    victim={ victim }
                                    audience={ audience}
                                />
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AudienceVictims;